export default "__VITE_ASSET__D5I7i3tC__"